import React from "react";
import { Container, NavbarBrand } from "reactstrap";
import FootpringSvg from "../../../assets/Footprints-Logo.svg";
import { Link } from "react-router-dom";
import { StyledNavbar } from "./styles";

const LoggedOutHeader = () => {
  const logo = {
    imgAlt: "Footprints-Logo",
    imgSrc: require("../../../assets/Footprints-Logo.svg"),
  };
  let navbarBrandProps = {
    to: logo.innerLink,
    tag: Link,
  };
  return (
    <>
      <StyledNavbar>
        <Container className="d-flex justify-content-center">
          {" "}
          <NavbarBrand {...navbarBrandProps}>
            <img
              alt={logo.imgAlt}
              className=" img-fluid"
              src={FootpringSvg}
              style={{ margin: "auto" }}
            />
          </NavbarBrand>
        </Container>
      </StyledNavbar>
    </>
  );
};

export default LoggedOutHeader;
